import { Result, backendApi, TrimValidationFields } from "./backendApi";

export interface MakeModel {
  code?: string;
  name?: string;
}

class CreateMakeRequest {
  make?: MakeModel;
}

class UpdateMakeRequest {
  code?: string;
  make?: MakeModel;
}

class GetMakesRequest {}

class GetMakesResponse {
  makes?: MakeModel[];
}

class GetAvailableMakeCodesRequest {
  makeCode?: string;
}

class GetAvailableMakeCodesResponse {
  makeCodes?: string[];
}

export const makeAPI = {
  async getMakes(): Promise<Result<MakeModel[]>> {
    let response = await backendApi.sendAndGetResponseAsync<GetMakesResponse>(
      "GetMakes",
      new GetMakesRequest(),
    );

    if (response.ok) {
      return { ok: true, value: response.value.makes ?? [] };
    }

    return response;
  },

  async getAvailableMakeCodes(makeCode?: string): Promise<Result<string[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetAvailableMakeCodesResponse>(
        "GetAvailableMakeCodes",
        {
          makeCode: makeCode,
        } as GetAvailableMakeCodesRequest,
      );

    if (response.ok) {
      return { ok: true, value: response.value.makeCodes ?? [] };
    }

    return response;
  },

  async updateMake(make: MakeModel): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateMake", {
      code: make.code,
      make: make,
    } as UpdateMakeRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "Make");

    return response;
  },

  async createMake(make: MakeModel): Promise<Result<any>> {
    let response = await backendApi.sendAsync("CreateMake", {
      make: make,
    } as CreateMakeRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "Make");

    return response;
  },
};
